<template>
  <div style="display: flex; flex-direction: column">
    <div>
      <el-button
        :disabled="disabled"
        type="primary"
        @click="getPackingInformation"
      >
        {{ $t('SeaExport.GetPackingInformation') }}
      </el-button>
    </div>
    <cargo-input
      v-model="cargoDoc.container"
      :disabled="disabled"
      :auto-uppercase="true"
      type="textarea"
      :rows="5"
      style="width:100%"
      :filter-chars="false"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'

export default {
  name: 'SeHblContainer',
  components: { cargoInput },
  props: {
    job: { type: Object, default: () => { return {} } },
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    getPackingInformation() {
      if (this.job.containerLoadType !== 'BB') {
        this.cargoDoc.container = SeaExportUtils.getContainerDesc(this.job, false)
      } else {
        this.cargoDoc.container = SeaExportUtils.getContainerDesc(this.job, this.cargoDoc.printParam3)
      }
    }
  }
}
</script>
